import React from "react";

import aboutImg from "../../../../assets/banner-8.jpg";
const About = () => {
  return (
    <div className="about-container">
      <div className="row container my-5 mx-auto">
        <div className="col-lg-6 col-md-6 col-12 my-5 ">
          <img className="img-fluid  about-img " src={aboutImg} alt="" />
        </div>
        <div className="col-lg-6 col-md-6 mt-5 col-12 py-5 about">
          <h1 className="fw-bold my-4  about-top-title ">
            Jannatul ferdous <span className="fs-2 about-span">HAPPY </span>
          </h1>
          <p className="t about-sub-title fs-5"><i className="fas fa-grip-lines me-2 mt-2"></i>I am 23 years old Bangladeshi; MERN stack Developer and self taught web designer</p>
          <p className="pe-5 ">
            I am a Self-motivated, adaptable, and ambitious Web Developer. and
            an enthusiastic learner of new technologies to gain confidence and
            experience in the field of Full-Stack Web Development, and express
            my innovative, and creative skills through unique leadership and
            teamwork for the company and self-development. Improves properties
            and streamlines operations for efficiency. Hardworking and
            resourceful with a friendly and professional demeanor.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
